import { useMediaQuery } from 'react-responsive';

import useGoBack from '@/hooks/useGoBack';
import useTranslations from '@/i18n/useTranslations';
import BackArrowIcon from '@/shared-components/icons/components/public/BackArrowIcon';

import './AlertHeader.css';

export default function AlertHeader( { className="" } ) {
  const t = useTranslations('common.notifications');
  const isMobile = useMediaQuery({ query: '(max-width: 650px)' });

  const goBackHandler = useGoBack("/profile");

  return (
    <>
      <div className={ 'notification__header ' + className }>
        <div className='notification-header__back-section'>
          {!isMobile && 
              <BackArrowIcon className='notification-header__back-icon' onClick={goBackHandler}/>
          }
          <p className='notification__header__title'>
            {t('title')}
          </p>
        </div>
      </div>
    </>
  );
}
